<template>
    <el-form ref="areas" :inline="true"  :model="selectItem" :rules="formRules">
      <div class="areaWrap">
          <div class="cell">
            <el-form-item prop='province'>
              <el-select :value="selectItem.province" placeholder="请选择" @change="onChangeProvince" class="selectUi">
                <el-option v-for="item in provinceData" :key="item.value" :label="item.label" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="cell gutter">
            <el-form-item prop='city'>
              <el-select :value="selectItem.city" placeholder="请选择" @change="onChangeCity" class="selectUi">
                <el-option v-for="item in cityData" :key="item.value" :label="item.label" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="cell">
            <el-form-item prop='area'>
              <el-select :value="selectItem.area" placeholder="请选择" @change="onChangeArea" class="selectUi">
                <el-option v-for="item in areaData" :key="item.value" :label="item.label" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
      </div>
    </el-form>
</template>

<script>
import provincesArr from '../../utils/provinces';
import cityObj from '../../utils/cities';
import districtObj from '../../utils/districts';
import { hanldeCode } from '../../utils/index';
import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data';
export default {
  props: {
    preSelectItem: {
      type: Object,
      default: () => {
        return {
          province: '',
          city: '',
          area: '',
          areaCode: ''
        }
      },
    }
  },
  watch: {
    preSelectItem(obj) {
      this.selectItem = obj;
    }
  },
  data() {
    return {
      regionData: regionData,
      provinceData: regionData,
      cityData: [],
      areaData: [],
      selectItem: this.preSelectItem,
      formRules: {
          province: [{required: true,message: '请选择所在省',trigger: 'change'}],
          city: [{required: true,message: '请选择所在城市',trigger: 'change'}],
          area: [{required: true,message: '请选择所在区',trigger: 'change'}]
        },
    };
  },
  created() {
    // console.log('regionData:', regionData);
  },
  methods: {
    onChangeProvince: function (item) {
      if (item.children[0].label == '市辖区') {
        item.children[0].label = item.label;
        // console.log('label', item.children[0].label, item.label);
      }
      this.cityData = item.children;
      this.areaData = [];
      this.selectItem = { province: item.label, city: '', area: '', areaCode: item.value };
    },
    onChangeCity: function (item) {
      const { province } = this.selectItem;
      this.areaData = item.children;
      this.selectItem = { province, city: item.label, area: '', areaCode: item.value };
    },
    onChangeArea: function (item) {
      const { province, city } = this.selectItem;
      this.selectItem = { province, city, area: item.label, areaCode: item.value };
    },
    getCode(item) {
      const data = hanldeCode(item.areaCode);
      if (data) {
        const { province, city } = data;
        this.cityData = cityObj[province];
        this.areaData = districtObj[city];
        this.selectItem = {
          province: item.province,
          city: item.city,
          area: item.area,
          areaCode: item.areaCode
        };
      } else {
        this.selectItem = {
          province: '',
          city: '',
          area: '',
          areaCode: ''
        };
      }
    },
    validateForm () {
        let flag = null
        this.$refs.areas.validate(valid => {
          if (valid) {
            flag = true
          } else {
            flag = false
          }
        })
        return flag
      }
  }
};
</script>

<style scoped>
.areaWrap {
    width: 500px;
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}
.cell {
    flex: 1;

}
.cell /deep/ .el-form-item{
      margin-bottom: 0;
}
.el-select {
    width: 100%;
}
.gutter {
    margin-right: 20px;
    margin-left: 20px;
}
</style>
